import { useState, useEffect } from "react";
import AdminLayout from "../layouts/AdminLayout";
import PageTitle from "../components/ui/PageTitle";
import { Save, User, Mail, Lock } from "lucide-react";
import api from "../../services/api";
import toast from "react-hot-toast";

export default function Profile() {
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "", // Password blank chhodenge taaki jab change karna ho tabhi type kare
  });

  // Page load hote hi profile data mangwana
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("admin_token");
        const response = await api.get("/admin/profile", {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        setFormData({
          name: response.data.name || "",
          email: response.data.email || "",
          password: "", 
        });
      } catch (error) {
        toast.error("Failed to load profile data");
      } finally {
        setFetching(false);
      }
    };
    fetchProfile();
  }, []);

  // Profile Update karna
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("admin_token");
      const response = await api.put("/admin/profile", formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      toast.success("Profile updated successfully!");
      // LocalStorage mein naya data save kar do taaki header/sidebar mein naam update ho jaye
      localStorage.setItem("admin", JSON.stringify(response.data.user));
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update profile");
    } finally {
      setLoading(false);
    }
  };

  if (fetching) return <AdminLayout><div className="p-8">Loading Profile...</div></AdminLayout>;

  return (
    <AdminLayout>
      <PageTitle title="My Profile" subtitle="View and update your personal account details." />

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 max-w-2xl mt-6">
        <form onSubmit={handleSubmit} className="space-y-6">
          
          {/* Name Field */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Full Name</label>
            <div className="relative">
              <User className="absolute left-4 top-3 text-gray-400" size={18} />
              <input 
                type="text" 
                required 
                value={formData.name} 
                onChange={(e) => setFormData({...formData, name: e.target.value})} 
                className="w-full border border-gray-300 rounded-lg pl-11 pr-4 py-2.5 outline-none focus:ring-2 focus:ring-yellow-500" 
              />
            </div>
          </div>

          {/* Email Field */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
            <div className="relative">
              <Mail className="absolute left-4 top-3 text-gray-400" size={18} />
              <input 
                type="email" 
                required 
                value={formData.email} 
                onChange={(e) => setFormData({...formData, email: e.target.value})} 
                className="w-full border border-gray-300 rounded-lg pl-11 pr-4 py-2.5 outline-none focus:ring-2 focus:ring-yellow-500" 
              />
            </div>
          </div>

          {/* Password Field (Optional) */}
          <div className="pt-4 border-t border-gray-100">
            <label className="block text-sm font-medium text-gray-700 mb-2">New Password (Optional)</label>
            <p className="text-xs text-gray-500 mb-3">Leave this blank if you don't want to change your current password.</p>
            <div className="relative">
              <Lock className="absolute left-4 top-3 text-gray-400" size={18} />
              <input 
                type="password" 
                placeholder="••••••••"
                minLength="6"
                value={formData.password} 
                onChange={(e) => setFormData({...formData, password: e.target.value})} 
                className="w-full border border-gray-300 rounded-lg pl-11 pr-4 py-2.5 outline-none focus:ring-2 focus:ring-yellow-500" 
              />
            </div>
          </div>

          <div className="pt-4">
            <button disabled={loading} type="submit" className="flex items-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-black font-semibold py-2.5 px-8 rounded-lg transition-colors">
              <Save size={18} /> {loading ? "Updating..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </AdminLayout>
  );
}